import axios from 'axios'
import { urlLoginDenganNext } from './auth'

const api = axios.create({ baseURL: '/api' })

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = urlLoginDenganNext(window.location.pathname + window.location.search)
    }
    return Promise.reject(err)
  }
)

export default api
